/**
 * Type definitions for the External Custom Filter component
 */

/**
 * Mapping of field IDs to AG Grid column names
 */
export type FieldIds = {
  batchCode: string
  claimStatusPayer: string
  owner: string
  patientLastName: string
  memberId: string
  visitId: string
  uniqueIdentifier: string
  admitDate: string
  oaiWorked: string
  appealStatus: string
}

/**
 * Form state for all filter inputs
 */
export type FilterFormState = {
  batchCode: string
  claimStatusPayer: string[]
  owner: string[]
  patientLastName: string
  memberId: string
  visitId: string
  uniqueIdentifier: string
  admitDateFrom: string
  admitDateTo: string
  admitDateOperator?: 'range' | 'less-than' | 'greater-than'
  oaiWorkedFrom: string
  oaiWorkedTo: string
  oaiWorkedOperator?: 'range' | 'less-than' | 'greater-than'
  appealStatus: string[]
}

/**
 * Last modified quick filter state
 */
export type LastModifiedQuickState = {
  model: any | null
  text: string
}

/**
 * Default field mapping for AG Grid columns
 */
export const DEFAULT_FIELDS: FieldIds = {
  batchCode: 'batchCode',
  claimStatusPayer: 'claimStatusPayer',
  owner: 'owner',
  patientLastName: 'patientLastName',
  memberId: 'memberId',
  visitId: 'visitId',
  uniqueIdentifier: 'uniqueIdentifier',
  admitDate: 'admitDate',
  oaiWorked: 'oaiWorked',
  appealStatus: 'appealStatus'
}

/**
 * Initial empty state for filter form
 */
export const INITIAL_FILTER_FORM_STATE: FilterFormState = {
  batchCode: '',
  claimStatusPayer: [],
  owner: [],
  patientLastName: '',
  memberId: '',
  visitId: '',
  uniqueIdentifier: '',
  admitDateFrom: '',
  admitDateTo: '',
  admitDateOperator: undefined,
  oaiWorkedFrom: '',
  oaiWorkedTo: '',
  oaiWorkedOperator: undefined,
  appealStatus: []
}
